// SuccessPage.js
import React from 'react';

const MeetingOverPage = () => {
	return (
		<div style={{ marginLeft: 50 }}>
			<h1>Meeting End !</h1>
			<p>Your class is over you can leave now</p>
		</div>
	);
};

export default MeetingOverPage;